import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  IconButton,
  Grid,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditServiceProviderModal from "../SuperAdminDashboard/ServiceProvidersManagement/EditServiceProviderModal";
import LoadingAnimation from "../../Animations/LoadingAnimation";
import { noOutline } from "../../../Styles/Styles";

export default function BusinessProfile({ data, refreshData }) {
  const [profileData, setProfileData] = useState(data);
  const [editedProfileData, setEditedProfileData] = useState({
    name: "",
    description: "",
    contactInfo: {
      email: "",
      phone: "",
      countryCode: "",
    },
    address: "",
  });
  const [openModal, setOpenModal] = useState(false); // State to control modal visibility

  useEffect(() => {
    if (data) {
      setProfileData(data);
      setEditedProfileData({
        name: data.name,
        description: data.description,
        contactInfo: data.contactInfo,
        address: data.address,
      });
    }
  }, [data]);

  const handleEditClick = () => {
    setOpenModal(true); // Open the modal when edit is clicked
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleSave = (updatedData) => {
    setProfileData(updatedData); // Update the profile with the data from modal
    setOpenModal(false); // Close the modal after saving
    refreshData();
  };

  if (!profileData) {
    return <LoadingAnimation />;
  }

  return (
    <>
      <IconButton size="small" onClick={handleEditClick} sx={{ ...noOutline }}>
        <EditIcon sx={{ color: "var(--primary-color)" }} />
      </IconButton>
      {/* Modal to edit profile */}
      <EditServiceProviderModal
        open={openModal}
        onClose={handleCloseModal}
        data={profileData} // Pass the profile data to the modal
        onSave={handleSave} // Handle save logic in parent component
      />
    </>
  );
}
